import React from "react";
import BlogSeven from "../component/BlogSeven";

function BlogSevenContainer() {
  return <BlogSeven />;
}
export default BlogSevenContainer;
